module.exports = __webpack_public_path__ + "static/media/seamless_integration.c92fd82c.svg";